<div class="sg-tool-tip">
    <div class="row mx-0">
        <div class=" pr-1 pl-0" *ngIf='!params.data.docType'>
            <span class="sg-foldericon">
                <span class="material-icons-outlined">folder</span>
            </span>
        </div>
        <div class="col-1 pr-1 pl-0" *ngIf='params.data.docType'>
            <span class="sg-foldericon">
                <span class="material-icons-outlined">description</span>
            </span>
        </div>
        <div class="pr-1 pl-0"  [ngClass]='params.data.name && !params.data.docType ? "pl-0" : "col-8" '>
            <span class="sg-cell-value">{{params.value}}</span>
        </div>
        <div class="col-3 pr-0 pl-0" *ngIf='params.data.docType && params.data.id'>
            <span class="sg-foldericon float-right">
                <span class="material-icons edit_details_icon" *ngIf='params.data.hasPermission'  (click)="editClickHandler(params.data)"> mode_edit</span>
                <span class="material-icons preview-icon" (click)="onPreviewIconClick(params.data)">visibility</span>
                <span class="material-icons download_edit_icon" (click)="downloadClickHandler(params.data)">file_download</span>
            </span>
        </div>
        <div class=" pr-1 pl-0" *ngIf='!params.data.docType'>
            <span class="sg-infoicon cursor-pointer">
                     <p class="material-icons-outlined"  [tooltip]="template" contentType="template" [options]="tooltipOptions"
                     tooltipClass="tooltip-feedback">help_outline</p>
                    <ng-template #template class="w-100">
                        <div class="row mx-0 w-100" >
                            <div class="col-12 w-100 px-0">
                                <div class="row mx-0 mb-1 w-100" *ngIf="subFolderName.length > 0">
                                    <div class="col-12 px-0">
                                        <span style="font-weight: 600;font-size: 1rem;">Sub Folders: </span>
                                        <span style="font-size: 0.9rem;">{{subFolder}}</span>
                                    </div>
                                </div>
                                <div class="row mx-0 mb-1 w-100" *ngIf="subFolderName.length === 0 || docomentName.length > 0">
                                    <div class="col-12 px-0">
                                        <span style="font-weight: 600;font-size: 1rem;">Documents: </span>
                                        <span style="font-size: 0.9rem;">{{documentsName}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
            </span>
        </div>
    </div>
</div>